export enum PAGE {
    ESTIMATE = 'estimate',
    SUMMARY = 'summary',
}
